/**
 * Web stub for `react-native-geolocation-service`.
 * Delegates to the browser's `navigator.geolocation` API so the same
 * timeClockSlice code runs in the web preview.
 */

interface Position {
  coords: { latitude: number; longitude: number; accuracy: number };
  timestamp: number;
}

type SuccessCb = (pos: Position) => void;
type ErrorCb = (err: { code: number; message: string }) => void;

const getCurrentPosition = (success: SuccessCb, error?: ErrorCb, opts?: PositionOptions): void => {
  if (typeof navigator === 'undefined' || !navigator.geolocation) {
    error?.({ code: 2, message: 'Geolocation not available' });
    return;
  }
  navigator.geolocation.getCurrentPosition(
    (p) => success({
      coords: {
        latitude: p.coords.latitude,
        longitude: p.coords.longitude,
        accuracy: p.coords.accuracy,
      },
      timestamp: p.timestamp,
    }),
    (e) => error?.({ code: e.code, message: e.message }),
    opts,
  );
};

const Geolocation = {
  getCurrentPosition,
  requestAuthorization: async () => 'granted' as const,
  watchPosition: () => 0,
  clearWatch: () => undefined,
};

export default Geolocation;
